// import { Grid } from "@mui/material";
// import React from "react";
// import WSDataGridNew, {
//   IColumns,
// } from "../../Components/DataGrid/WSDataGridNew";
// import { IHeaderRows } from "../../Components/Filter/WSHeaderFilter";
// import { WSIcons } from "../../commonFunctions/iIcons";
// import { ReactComponent as ArrowUpwordCorner } from "../../images/ArrowCorner.svg";

// export const RecentOrders: React.FC<any> = React.memo((props) => {
//   const columns: IColumns[] = [
//     {
//       header: "Order ID",
//       fieldName: "",
//       type: "default",
//       // sortable: true
//     },
//     {
//       header: "Customer",
//       fieldName: "",
//       type: "default",
//     },
//     {
//       header: "Products",
//       fieldName: "mode",
//       type: "default",
//     },

//     {
//       header: "Status",
//       fieldName: "status",
//       type: "status",
//     },
//     {
//       header: "Time",
//       fieldName: "status",
//       type: "status",
//     },
//     {
//       header: "Actions",
//       fieldName: "actions",
//       type: "action",
//       actions: ["Edit"].filter(Boolean),
//       // actionCallback: (action, row) => handleAction(action, row),
//       // hideSelectedActions: {
//       //     fieldToHide: [
//       //         {
//       //             field: 'status',
//       //             hideValue: ['Incomplete'],
//       //             hideActions: ['Edit']
//       //         },
//       //         // {
//       //         //     field: 'profileStatus',
//       //         //     hideValue: ['Approved'],
//       //         //     hideActions: ['Approve']
//       //         // }
//       //     ]
//       // }
//     },
//   ];

//   const filterRows: IHeaderRows[] = [
//     {
//       label: "All",
//       fieldName: "",
//       type: "dropdown",
//       options: [
//         { label: "All", value: "all" },
//         { label: "Pending", value: "pending" },
//         { label: "Processing", value: "processing" },
//         { label: "Delivered", value: "delivered" },
//       ],
//       operator: "eq",
//       rowDivision: 3,
//     },
//   ];
//   return (
//     <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//       {
//         <Grid item sm={12}>

          
//           <WSDataGridNew
//             columns={columns}
//             id="recentOrderListGrid"
//             title="Recent Orders"
//             filterFields={filterRows}
//             addButton={{ label: "New", color: "secondary" }}
//             gridHeaderSx={{
//               backgroundColor: "whitesmoke",
//               border: "1px solid whitesmoke",
//             }}
//           />
//         </Grid>
//       }
//     </Grid>
//   );
// });


import { Grid, Snackbar, Alert, Typography } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import WSDataGridNew, { IColumns } from "../../Components/DataGrid/WSDataGridNew";
import { IHeaderRows } from "../../Components/Filter/WSHeaderFilter";
import { WSIcons } from "../../commonFunctions/iIcons";
import { ReactComponent as ArrowUpwordCorner } from "../../images/ArrowCorner.svg";
import { useNavigate } from "react-router-dom";
import http from "../../commonFunctions/httpClient"; // Adjust path as needed
import { getLocalValue, LoacalVariables } from "../../commonFunctions/CommonFunctions";
import { UpdateStatus } from "../Pharmacy/PharmacyOrder/updateStatus" // Adjust path as needed

interface RecentOrder {
  id: string;
  orderId: string;
  patientName: string | null;
  price: number;
  itemsCount: number;
  paymentStatus: string;
  orderDate: string;
  status: string;
  actions: string;
}

export const RecentOrders: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  
  const [vendorId, setVendorId] = useState<string>("");
  const [orders, setOrders] = useState<RecentOrder[]>([]);
  const [loading, setLoading] = useState(true);

  // Status Dialog State
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<string | null>(null);
  const [selectedStatus, setSelectedStatus] = useState("");

  // Snackbar State
  const [snackbar, setSnackbar] = useState<{ 
    open: boolean; 
    message: string; 
    severity: 'success' | 'error' 
  }>({
    open: false,
    message: '',
    severity: 'success'
  });

  // Get vendorId from localStorage
  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    setVendorId(userId || "");
  }, []);

  const fetchOrders = useCallback(async () => {
    if (!vendorId) {
      console.log("⏳ Waiting for vendorId...");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      console.log("📡 FETCHING RECENT ORDERS FOR VENDOR:", vendorId);
      const response: any = await http.get(`pharmacy/ph_order_/ByVendor/${vendorId}`);
      console.log("📦 FULL API RESPONSE:", response);
      
      let data: RecentOrder[] = [];
      if (response && Array.isArray(response.data)) {
        data = response.data.map((order: any) => ({
          id: order.orderId, 
          orderId: order.orderId || order.orderNumber || "N/A", 
          patientName: order.userName || "Unknown", 
          price: order.totalAmount || 0, 
          itemsCount: order.itemCount || 0, 
          paymentStatus: order.paymentMethod || "N/A", 
          orderDate: order.orderDate || "N/A", 
          status: order.status || "Pending", 
          actions: order.orderId
        }));
      }
      
      console.log("📦 TRANSFORMED DATA:", data);
      setOrders(data);
    } catch (error: any) {
      console.error("💥 API ERROR:", error);
      setOrders([]);
      setSnackbar({
        open: true,
        message: "Failed to load recent orders",
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  }, [vendorId]);

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  // Status Change Handlers
  const handleStatusChangeClick = useCallback((orderId: string) => {
    setSelectedOrder(orderId);
    setConfirmOpen(true);
  }, []);

  const handleConfirmStatusChange = useCallback(async () => {
    if (selectedOrder && selectedStatus && vendorId) {
      try {
        console.log("📤 UPDATING STATUS:", { orderId: selectedOrder, status: selectedStatus, vendorId });
        
        const response: any = await http.put(`pharmacy/Ph_Order_/update-status`, {
          orderId: selectedOrder,
          status: selectedStatus,
          vendorId: vendorId
        });

        console.log("✅ STATUS UPDATE RESPONSE:", response);

        if (response?.success) {
          // Update local state immediately (optimistic update)
          setOrders(prevOrders => 
            prevOrders.map(order => 
              order.id === selectedOrder 
                ? { ...order, status: selectedStatus }
                : order
            )
          );
          
          setSnackbar({
            open: true,
            message: `Order status updated to ${selectedStatus}`,
            severity: 'success'
          });
        } else {
          throw new Error(response?.message || "Status update failed");
        }
      } catch (error: any) {
        console.error("💥 Status Update Error:", error);
        setSnackbar({
          open: true,
          message: error?.response?.data?.message || error?.message || "Failed to update status",
          severity: 'error'
        });
      }
    }
    
    // Reset dialog
    setConfirmOpen(false);
    setSelectedOrder(null);
    setSelectedStatus("");
  }, [selectedOrder, selectedStatus, vendorId]);

  const handleCancelStatusChange = useCallback(() => {
    setConfirmOpen(false);
    setSelectedOrder(null);
    setSelectedStatus("");
  }, []);

  // Action Handler
  const handleAction = useCallback((action: string, row: RecentOrder) => {
    console.log("🔧 ACTION:", action, "ROW:", row);
    
    switch (action) {
      case "Update Status":
        handleStatusChangeClick(row.id);
        break;
      case "View":
        navigate(`/pharmacy-order-details/${row.id}`);
        break;
      default:
        console.log("Unknown action:", action);
    }
  }, [navigate, handleStatusChangeClick]);

  const columns: IColumns[] = [
    { 
      header: "Order ID", 
      fieldName: "orderId", 
      type: "default" 
    },
    { 
      header: "Customer", 
      fieldName: "patientName", 
      type: "default" 
    },
    { 
      header: "Products", 
      fieldName: "itemsCount", 
      type: "default" 
    },
    { 
      header: "Price", 
      fieldName: "price", 
      type: "default" 
    },
    { 
      header: "Status", 
      fieldName: "status", 
      type: "status" 
    },
    { 
      header: "Time", 
      fieldName: "orderDate", 
      type: "date" 
    },
    { 
      header: "Actions", 
      fieldName: "actions", 
      type: "action", 
      actions: ["Update Status", "View"],
      actionCallback: handleAction 
    }
  ];

  const filterRows: IHeaderRows[] = [
    {
      label: "Status",
      fieldName: "status",
      type: "dropdown",
      options: [
        { label: "All", value: "all" },
        { label: "Pending", value: "Pending" },
        { label: "packed", value: "packed" },
        { label: "Shipped", value: "Shipped" },
        { label: "Delivered", value: "Delivered" },
      ],
      operator: "eq",
      rowDivision: 3,
    }
  ];

  const handleSnackbarClose = useCallback(() => {
    setSnackbar({ open: false, message: '', severity: 'success' });
  }, []);

  if (loading) {
    return (
      <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
        <Grid item sm={12} display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <div>Loading recent orders...</div>
        </Grid>
      </Grid>
    );
  }

  return (
    <>

    <Grid
      container
      alignItems="center"
      justifyContent="space-between"
      sx={{
        px: 2,
        py: 2,
        backgroundColor: "#ffffff",
        borderRadius: "12px 12px 0 0",
      }}
    >
      <Grid item>
        <Typography fontSize={20} fontWeight={600}>
          Recent Product Order
        </Typography>
        {/* <Typography fontSize={14} color="text.secondary" mt={0.5}>
          Check your most recent prescription orders here.
        </Typography> */}
      </Grid>
    </Grid>

    {/* TABLE */}
    <Grid container spacing={2} sx={{ px: 1 }}>
        <Grid item sm={12}>
          <WSDataGridNew
            columns={columns}
            id="recentOrderListGrid"
            title={`Recent Orders (${orders.length})`}
            data={orders}
            filterFields={filterRows}
            searchBox={{ fieldName: "patientName" }}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
      </Grid>

      {/* UpdateStatus Dialog */}
      <UpdateStatus 
        confirmOpen={confirmOpen}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        handleCancelStatusChange={handleCancelStatusChange}
        handleConfirmStatusChange={handleConfirmStatusChange}
      />

      {/* Snackbar Notifications */}
      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={4000} 
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleSnackbarClose} 
          severity={snackbar.severity} 
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
});

export default RecentOrders;
